import { gql } from '@apollo/client';

export const GET_ORDER_REPRINT_DAILY_STATS = gql`
    query GetOrderReprintDailyStats(
        $hubId: Long
        $warehouseId: Long
        $startTime: Long
        $endTime: Long
        $accountId: Long
        $source: Int
    ) {
        getOrderReprintDailyStats(
            hubId: $hubId
            warehouseId: $warehouseId
            startTime: $startTime
            endTime: $endTime
            accountId: $accountId
            source: $source
        ) {
            date
            total
            success
            failed
            successRate
            avgProcessingTimeMs
            errorDistribution {
                failureType
                count
            }
        }
    }
`;

export interface OrderReprintErrorCount {
    failureType: number;
    count: number;
}

export interface OrderReprintDailyStatsItem {
    date: string;
    total: number;
    success: number;
    failed: number;
    successRate: number;
    avgProcessingTimeMs: number;
    errorDistribution: OrderReprintErrorCount[];
}

export interface OrderReprintDailyStatsResponse {
    getOrderReprintDailyStats: OrderReprintDailyStatsItem[];
}
